import { Button, Col, Modal, Row } from "antd";
import React from "react";
import { TituloModal } from "../../../../components/tituloModal/TituloModal";
import { formatCurrency } from "../../../../utils/formatCurrency";

export const ContenidoModal = ({ setOpen, open, desglose }) => {
  const subtotal = (item) =>
    item.cantidad === null ? item.costo : item.cantidad * item.costo;

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={[
        <Button danger onClick={() => setOpen(false)} size="small">
          cerrar
        </Button>,
      ]}
      title={<TituloModal texto="Datos Presupuestados" />}
    >
      <Row style={{ fontWeight: 600, marginBottom: 5 }}>
        <Col span={4} style={{ textAlign: "right" }}>Cantidad</Col>
        <Col span={9}>Concepto</Col>
        <Col span={5} style={{ textAlign: "right" }}>Precio unitario</Col>
        <Col span={6} style={{ textAlign: "right" }}>Subtotal</Col>
      </Row>
      {desglose.map((item, index) => (
        <Row key={index} className="rowItemElementoSmall">
          <Col span={4} style={{ textAlign: "right" }}>
            {item.cantidad === null ? "-" : item.cantidad}
          </Col>
          <Col span={9}>{item.tipoCosto}</Col>
          <Col span={5} style={{ textAlign: "right" }}>
            {formatCurrency(item.costo)}
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            {formatCurrency(subtotal(item))}
          </Col>
        </Row>
      ))}
      <div style={{ marginTop: 5, fontWeight: 600, textAlign: "right" }}>
        Total:{" "}
        {formatCurrency(desglose.reduce((total, item) => total + subtotal(item), 0))}
      </div>
    </Modal>
  );
};
